import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { ContactReportService, ToasterLibraryService, AppConfig } from '@service/index';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-contact-sold-net-profit-count-widget',
  templateUrl: './contact-sold-net-profit-count-widget.component.html',
  styleUrls: ['./contact-sold-net-profit-count-widget.component.scss']
})

// @Privilege({
//   privilege: 'emailtemplates:can_get_emailtemplates_reports_sent'
// })
export class ContactSoldNetProfitCountWidgetComponent implements OnInit, OnChanges {
  @Input() relativeDate: any = '';
  @Input() criteriaArray: any;
  @Input() campaignData: any;
  @Input() formData: any;
  @Input() priceData: any;
  public isCountLoaded = false;
  public contactsSoldCount: any = 0;
  @Input() widgetTitle = 'Gross Profit';
  public appContactSoldOptions = AppConfig.contactSoldOptions;
  constructor(
    private contactReportService: ContactReportService,
    private toasterLibrary: ToasterLibraryService,
    private permissionService: NgxPermissionsService
  ) { }
  ngOnInit() {
    if (this.permissionService.hasPermission('contacts:can_get_contacts_net_profit')) {
      this.criteriaArray = JSON.parse(localStorage.getItem('leadsCriteria'));
      // console.log(this.criteriaArray);
      this.requestContactsSoldCount();
    }
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (this.permissionService.hasPermission('contacts:can_get_contacts_net_profit')) {
      if (
        (changes['relativeDate'] && !changes['relativeDate'].isFirstChange()) ||
        (changes['campaignData'] && !changes['campaignData'].isFirstChange()) ||
        (changes['criteriaArray'] && !changes['criteriaArray'].isFirstChange()) ||
        (changes['priceData'] && !changes['priceData'].isFirstChange()) ||
        (changes['formData'] && !changes['formData'].isFirstChange())
      ) {
        this.requestContactsSoldCount();
      }
    }
  }

  requestContactsSoldCount() {
    const criteriaArray: any = this.getCommonCriteria() || [];

    this.isCountLoaded = false;
    this.contactReportService.getContactSoldNetProfit(criteriaArray)
      .subscribe((res: any) => {
        this.contactsSoldCount = res.data;
        this.isCountLoaded = true;
      });
  }

  private getCommonCriteria() {
    const criteriaArray: any = [
      {
        is_required: true,
        criterion: 'dateRange',
        value: {
          relative_date: this.relativeDate
        }
      }
    ];

    if (this.campaignData && this.campaignData != "") {
      criteriaArray.push({
        'id': '',
        'value': { c_id: this.campaignData },
        'criterion': 'campaign',
        'is_required': true
      });
    }

    if (this.formData && this.formData != "") {
      criteriaArray.push({
        value: [this.formData],
        criterion: 'form',
        is_required: true,
        id: ''
      });
    }

    if (this.priceData && this.priceData != "") {
      criteriaArray.push({
        value: { rprice_id: this.priceData },
        criterion: 'leadPricing',
        is_required: true,
        id: 0
      });
    }
    return criteriaArray;
  }
}
